import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@carsys/ui'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/material'

interface IAddShopToCRMProps {
  shopID: string
  onAddShopToCRM: (shopID: string) => void
}

export const AddShopToCRM: React.FC<IAddShopToCRMProps> = ({ onAddShopToCRM, shopID }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant='body1' gutterBottom>
        {t('Shop.AddToCRMTitle')}
      </Typography>
      <Button data-testid='addShopToCRM' variant='contained' onClick={() => onAddShopToCRM(shopID)}>
        {t('Shop.AddToCRM')}
      </Button>
    </Box>
  )
}

AddShopToCRM.displayName = 'AddShopToCRM'

export default AddShopToCRM
